import React from 'react';
import PropTypes from 'prop-types';

function PageIcon({ color = 'black', width = 22, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 24"
      fill="none"
    >
      <path
        d="M20.3333 23.6663H1.66667C1.35725 23.6663 1.0605 23.5434 0.841709 23.3246C0.622916 23.1058 0.5 22.8091 0.5 22.4997V1.49967C0.5 1.19026 0.622916 0.893509 0.841709 0.674717C1.0605 0.455924 1.35725 0.333008 1.66667 0.333008H20.3333C20.6428 0.333008 20.9395 0.455924 21.1583 0.674717C21.3771 0.893509 21.5 1.19026 21.5 1.49967V22.4997C21.5 22.8091 21.3771 23.1058 21.1583 23.3246C20.9395 23.5434 20.6428 23.6663 20.3333 23.6663ZM19.1667 21.333V2.66634H2.83333V21.333H19.1667ZM6.33333 6.16634H15.6667V8.49967H6.33333V6.16634ZM6.33333 10.833H15.6667V13.1663H6.33333V10.833ZM6.33333 15.4997H15.6667V17.833H6.33333V15.4997Z"
        fill={color}
      />
    </svg>
  );
}

PageIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default PageIcon;
